(function () {
  "use strict";

  /* ---------- scroll reveal ---------- */
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var revealEls = document.querySelectorAll(".bmc-landing .reveal");
  if (reduce || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---------- fleet category filters ---------- */
  document.querySelectorAll(".bmc-landing .fleet-filters").forEach(function (bar) {
    var grid = bar.parentElement.querySelector(".fleet-grid");
    if (!grid) return;
    bar.addEventListener("click", function (e) {
      var btn = e.target.closest(".fleet-filter");
      if (!btn) return;
      var cat = (btn.getAttribute("data-category") || "").toLowerCase();
      bar.querySelectorAll(".fleet-filter").forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      grid.querySelectorAll(".vehicle-card").forEach(function (card) {
        var cc = (card.getAttribute("data-category") || "").toLowerCase();
        card.style.display = (!cat || cat === "all" || cc === cat) ? "" : "none";
      });
    });
  });

  /* ---------- form validation ----------
     Markup keeps its `novalidate` attribute (faithful to the standalone),
     so we validate required fields here. On success we do NOT preventDefault —
     the browser submits natively to the form's Formspree action. We only
     block submission (and surface a message) when a required field is empty
     or an email is malformed. */
  document.querySelectorAll(".bmc-landing form.enquire-form").forEach(function (form) {
    var status = form.querySelector(".form-status");

    form.addEventListener("submit", function (e) {
      if (status) status.classList.remove("error");
      var firstInvalid = null;
      var required = form.querySelectorAll("[required]");
      required.forEach(function (field) {
        var ok = field.value && String(field.value).trim() !== "";
        if (field.type === "email") {
          ok = ok && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value);
        }
        if (field.type === "checkbox") {
          ok = field.checked;
        }
        if (!ok) {
          field.classList.add("invalid");
          if (!firstInvalid) firstInvalid = field;
        } else {
          field.classList.remove("invalid");
        }
      });

      if (firstInvalid) {
        e.preventDefault();
        if (status) {
          status.textContent = "Please complete the highlighted fields.";
          status.classList.add("error");
        }
        firstInvalid.focus();
        return;
      }
      // valid — allow native POST to the form action (Formspree)
    });

    form.addEventListener("input", function (e) {
      if (e.target.classList && e.target.classList.contains("invalid")) {
        e.target.classList.remove("invalid");
      }
    });
  });
})();
